export default __webpack_public_path__ + "static/media/small_medium.7224d705.svg";